<template>
  <section class="configure" id="configure">
    <div class="inner">
      <div class="title">Configure & buy in 4 easy steps!</div>
      <div class="steps">
        <a href>
          <span>
            <i class="fa fa-arrows"></i>
          </span>
          Size and Wood Type
          <span>{{ sizeAndWoodType }}</span>
        </a>
        <div class="step-info default">
          <div class="row" v-if="priceList && !show_config">
            <label v-if="this.page.ParentID == IDs.doubleID">Gates Size (mm)</label>
            <label v-else-if="this.page.ParentID == IDs.garageID">Doors Size (mm)</label>
            <label v-else>Gate Size (mm)</label>
            <div class="option">
              <select @change="setDimensions" v-model="dimensions">
                <option :key="size._id" :value="size" v-for="size in priceList.sizes">
                  {{
                    "Height: " +
                    size.height +
                    "mm x Width: " +
                    size.width +
                    "mm:" +
                    (size.description ? " " + size.description : "") +
                    " £" +
                    size.price
                  }}
                </option>
              </select>
            </div>
            <div>
              <a @click.prevent="showMeasureModalWidth = true" class="help link-modal-height" href>
                <i class="fa fa-question-circle"></i>
                <span class="desktop">&lt; click here to see how to measure the width</span>
              </a>
            </div>
            <div>
              <a @click.prevent="showMeasureModalHeight = true" class="help link-modal-height" href>
                <i class="fa fa-question-circle"></i>
                <span class="desktop">&lt; click here to see how to measure the height</span>
              </a>
            </div>
            <div class="switch" v-if="this.page.ParentID !== IDs.saleID">
              <a @click.prevent="showConfig" href>
                <strong>Can’t find your size?</strong> Click here to try our bespoke options
              </a>
            </div>
          </div>

          <div class="row" v-show="show_config || !priceList">
            <div class="switch stock" v-show="priceList && this.page.ParentID !== IDs.saleID">
              <!--<a @click.prevent="hideConfig" href v-if="this.page.ParentID == IDs.saleID">
                <i class="fa fa-undo"></i> Switch back to standard sizes
              </a>-->
              <a @click.prevent="hideConfig" href>
                <strong>Don't want to wait?</strong> Click here for stock gates with next day dispatch
              </a>
            </div>

            <label v-if="this.page.ParentID == IDs.doubleID">Gates Height (mm)</label>
            <label v-else-if="this.page.ParentID == IDs.sidePanelID">Side Panel Height (mm)</label>
            <label v-else-if="this.page.ParentID == IDs.garageID">Doors Height (mm)</label>
            <label v-else>Gate Height (mm)</label>
            <div class="option">
              <input class="txt-size" type="text" v-model.lazy.number="height" />
            </div>
            <a
              @click.prevent="showMeasureModalHeight = true"
              class="help link-modal-height"
              href
              v-if="page.ParentID !== IDs.garageID"
            >
              <i class="fa fa-question-circle"></i>
              <span class="desktop">&lt; click here to see how to measure the height</span>
            </a>
          </div>
          <div class="row" v-show="page.ParentID == IDs.threeQuarterID && (show_config || !priceList)">
            <label>Left Width (mm)</label>
            <div class="option">
              <input class="txt-size" type="text" v-model.lazy.number="left_width" />
            </div>
          </div>
          <div class="row" v-show="show_config || !priceList">
            <label v-if="page.ParentID == IDs.doubleID">Gates Width (mm)</label>
            <label v-else-if="page.ParentID == IDs.sidePanelID">Side Panel Width (mm)</label>
            <label v-else-if="page.ParentID == IDs.garageID">Doors Width (mm)</label>
            <label v-else-if="page.ParentID == IDs.threeQuarterID">Right Width (mm)</label>
            <label v-else>Gate Width (mm)</label>

            <div class="option" v-if="page.ParentID != IDs.threeQuarterID">
              <input class="txt-size" type="text" v-model.lazy.number="width" />
            </div>
            <div class="option" v-if="page.ParentID == IDs.threeQuarterID">
              <input class="txt-size" type="text" v-model.lazy.number="right_width" />
            </div>

            <a
              @click.prevent="showMeasureModalWidth = true"
              class="help link-modal-height"
              href
              v-if="page.ParentID !== IDs.garageID"
            >
              <i class="fa fa-question-circle"></i>
              <span class="desktop">&lt; click here to see how to measure the width</span>
            </a>
          </div>
          <div
            class="row notice"
            v-if="page.price_type == 'Double' && page.ParentID != IDs.threeQuarterID && width > 0"
          >
            <i class="fa fa-info-circle"></i>
            You will receive 2 x {{ Number(width / 2) }}mm wide
            {{ page.ParentID !== IDs.garageID ? "gate leafs" : "garage doors" }}
          </div>
          <div
            class="row"
            v-if="page.price_type == 'Single' && page.ParentID !== IDs.sidePanelID && page.ParentID !== IDs.saleGatesID"
          >
            <label>Left / Right Hang</label>
            <div class="option">
              <select v-model.lazy="hang">
                <option value="Left">Left</option>
                <option value="Right">Right</option>
              </select>
            </div>
            <a
              @click.prevent="showHangModal = true"
              class="help link-modal-height"
              href
              v-if="misc && misc.how_to_choose_hang"
            >
              <i class="fa fa-question-circle"></i>
              <span class="desktop">&lt; click here to see how to choose hang type</span>
            </a>
          </div>
          <div class="row">
            <label>Wood Type</label>
            <div class="option">
              <select @change="woodTypeChanged" v-model.lazy="wood_type">
                <!-- <option value>Please choose...</option> -->
                <option v-if="!dimensions || dimensions.softwood" value="Scandinavian Redwood">
                  Scandinavian Redwood
                </option>
                <option v-if="!dimensions || dimensions.hardwood" value="African Iroko Hardwood">
                  African Iroko Hardwood
                </option>
              </select>
            </div>
            <a @click.prevent="showWoodModal = !showWoodModal" class="help link-modal-type" href>
              <i class="fa fa-question-circle"></i>
              <span class="desktop">&lt; click here for different wood types</span>
            </a>
            <base-modal :show="showWoodModal" @close="showWoodModal = false" v-if="misc">
              <div v-html="misc.hardwood_section"></div>
            </base-modal>
          </div>
          <p v-if="pricing">
            Total price:
            <strong>&pound;{{ totalPrice }}</strong>
          </p>
        </div>
        <a href>
          <span>
            <i class="fa fa-pause"></i>
          </span>
          Posts
          <span>{{ postsText }}</span>
        </a>
        <div class="step-info accessories">
          <div class="row divider">
            <h4>Posts</h4>
            <div class="grid">
              <a
                :key="post.ItemID"
                @click.prevent="showPostModal(post)"
                href
                v-for="post in filteredPosts"
                v-tooltip="{
                  content: post.promo
                }"
              >
                <img :src="post.image" />
                <span>{{ post.name }}</span>
              </a>
            </div>
          </div>
          <div class="selected" v-if="posts_selected.length">
            <p>
              <strong>Selected Posts</strong>
            </p>
            <div :key="index" v-for="(post, index) in posts_selected">
              <a @click.prevent="editPost(index)" class="edit" href>{{ post.name + " (" + post.option.name + ")" }}</a>
              <a @click.prevent="removePost(index)" class="del" href>
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
          <p v-if="pricing">
            Total price:
            <strong>£{{ totalPrice }}</strong>
          </p>
        </div>
        <a href>
          <span>
            <i class="fa fa-key"></i>
          </span>
          Ironmongery
          <span>{{ ironmongeryText }}</span>
        </a>
        <div class="step-info accessories">
          <div class="row divider">
            <h4>Ironmongery</h4>
            <div class="grid">
              <a
                :key="iron.ItemID"
                @click.prevent="showIronModal(iron)"
                href
                v-for="iron in filteredIronmongery"
                v-tooltip="{
                  content: iron.promo
                }"
              >
                <img :src="iron.image" />
                <span>{{ iron.name }}</span>
              </a>
            </div>
          </div>
          <div class="selected" v-if="ironmongery_selected.length">
            <p>
              <strong>Selected Ironmongery</strong>
            </p>
            <div :key="index" v-for="(iron, index) in ironmongery_selected">
              <a @click.prevent="editIron(index)" class="edit" href>{{ iron.name + " (" + iron.option.name + ")" }}</a>
              <a @click.prevent="removeIron(index)" class="del" href>
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
          <p v-if="pricing">
            Total price:
            <strong>£{{ totalPrice }}</strong>
          </p>
        </div>
        <a @click.prevent="scrollToConfigurator" href>
          <span>
            <i class="fa fa-paint-brush"></i>
          </span>
          Choose a treatment
          <span>{{ treatmentText }}</span>
        </a>
        <div class="step-info colours">
          <div class="row divider">
            <h4>Treatments</h4>
            <div class="grid">
              <a
                :key="treatment.ItemID"
                @click.prevent="showTreatmentModal(treatment)"
                href
                v-for="treatment in filteredTreatments"
                v-tooltip="{
                  content: treatment.promo
                }"
              >
                <img :src="treatment.image" />
                <span>{{ treatment.name }}</span>
              </a>
            </div>
          </div>

          <div class="selected" v-if="treatments_selected.length">
            <p>
              <strong>Selected Treatment</strong>
            </p>
            <div :key="index" v-for="(treatment, index) in treatments_selected">
              <a @click.prevent="editTreatment(index)" class="edit" href>{{
                treatment.name + " (" + treatment.option.name + ")"
              }}</a>
              <a @click.prevent="removeTreatment(index)" class="del" href>
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
          <p v-if="pricing">
            Total price:
            <strong>£{{ totalPrice }}</strong>
          </p>
        </div>
      </div>
      <div class="config-total" v-if="pricing">
        Total price for your customised product:
        <strong>£{{ totalPrice }}</strong>
        <div>
          <p class="error" v-show="error">Please enter the height, width and choose the wood type, thanks!</p>
          <p class="error" v-show="hang_error">Please choose a side for your gate to hang from, thanks!</p>
          <p class="error" v-show="size_error">
            The sizes you entered are outside the min/max available online. Please contact us for a quote on production
            at this size, thanks!
          </p>
          <a @click.prevent="addToCart" class="config-buy" href>
            <img alt="Add to cart" src="../assets/ripple.svg" /> Add to cart
          </a>
        </div>
      </div>
    </div>

    <base-modal :show="show_post_modal" @close="show_post_modal = false">
      <h3>{{ postToView.name }}</h3>
      <div class="modal-grid">
        <div>
          <img :src="postToView.image" class="limited" />
        </div>
        <div>
          <div v-html="postToView.description"></div>
          <div class="add-to-basket">
            Select an option:
            <select v-model.lazy="postOption">
              <option :key="option._id" :value="option" v-for="option in postToView.options">{{ option.name }}</option>
            </select>
            <button @click="addPost">Add</button>
          </div>
        </div>
      </div>
    </base-modal>

    <base-modal :show="show_iron_modal" @close="show_iron_modal = false">
      <h3>{{ ironToView.name }}</h3>
      <div class="modal-grid">
        <div>
          <img :src="ironToView.image" class="limited" />
        </div>
        <div>
          <div v-html="ironToView.description"></div>
          <div class="add-to-basket">
            Select an option:
            <select v-model.lazy="ironOption">
              <option :key="option._id" :value="option" v-for="option in ironToView.options">{{ option.name }}</option>
            </select>
            <button @click="addIron">Add</button>
          </div>
        </div>
      </div>
    </base-modal>

    <base-modal :show="show_treatment_modal" @close="show_treatment_modal = false">
      <h3>{{ treatmentToView.name }}</h3>
      <div class="modal-grid">
        <div>
          <img :src="treatmentToView.image" class="limited" />
        </div>
        <div>
          <div v-html="treatmentToView.description"></div>
          <div class="add-to-basket">
            Select an option:
            <select v-model.lazy="treatmentOption">
              <option :key="option._id" :value="option" v-for="option in treatmentToView.options">
                {{ option.name }}
              </option>
            </select>
            <button @click="addTreatment">Add</button>
          </div>
        </div>
      </div>
    </base-modal>

    <base-modal :show="showConfigureModal" @close="showConfigureModal = false">
      <p>You are now reconfiguring your order</p>
      <button @click="showConfigureModal = false" class="modal-btn">Ok, continue</button>
    </base-modal>

    <base-modal :show="showMeasureModalWidth" @close="showMeasureModalWidth = false">
      <img
        :src="misc.how_to_measure_single_width"
        v-if="misc && misc.how_to_measure_single_width && page.ParentID == IDs.singleID"
      />
      <img
        :src="misc.how_to_measure_double_width"
        v-if="misc && misc.how_to_measure_double_width && page.ParentID == IDs.doubleID"
      />

      <img
        :src="misc.how_to_measure_three_quarter_width"
        v-if="misc && misc.how_to_measure_three_quarter_width && page.ParentID == IDs.threeQuarterID"
      />
      <img
        :src="misc.how_to_measure_side_panels_width"
        v-if="misc && misc.how_to_measure_side_panels_width && page.ParentID == IDs.sidePanelID"
      />
      <img
        :src="misc.how_to_measure_5bar_single_width"
        v-if="
          misc && misc.how_to_measure_5bar_single_width && page.ParentID == IDs.fiveBarID && page.price_type == 'Single'
        "
      />
      <img
        :src="misc.how_to_measure_5bar_double_width"
        v-if="
          misc && misc.how_to_measure_5bar_double_width && page.ParentID == IDs.fiveBarID && page.price_type == 'Double'
        "
      />
    </base-modal>
    <base-modal :show="showMeasureModalHeight" @close="showMeasureModalHeight = false">
      <img
        :src="misc.how_to_measure_single_height"
        v-if="misc && misc.how_to_measure_single_height && page.ParentID == IDs.singleID"
      />
      <img
        :src="misc.how_to_measure_double_height"
        v-if="misc && misc.how_to_measure_double_height && page.ParentID == IDs.doubleID"
      />
      <img
        :src="misc.how_to_measure_three_quarter_height"
        v-if="misc && misc.how_to_measure_three_quarter_height && page.ParentID == IDs.threeQuarterID"
      />
      <img
        :src="misc.how_to_measure_side_panels_height"
        v-if="misc && misc.how_to_measure_side_panels_height && page.ParentID == IDs.sidePanelID"
      />
      <img
        :src="misc.how_to_measure_5bar_single_height"
        v-if="
          misc &&
          misc.how_to_measure_5bar_single_height &&
          page.ParentID == IDs.fiveBarID &&
          page.price_type == 'Single'
        "
      />
      <img
        :src="misc.how_to_measure_5bar_double_height"
        v-if="
          misc &&
          misc.how_to_measure_5bar_double_height &&
          page.ParentID == IDs.fiveBarID &&
          page.price_type == 'Double'
        "
      />
    </base-modal>
    <base-modal :show="showHangModal" @close="showHangModal = false">
      <img :src="misc.how_to_choose_hang" v-if="misc && misc.how_to_choose_hang" />
    </base-modal>
  </section>
</template>

<script>
import { mapState } from "vuex"
import shortid from "shortid"

export default {
  name: "Configurator",
  data: function() {
    return {
      dimensions: null,
      height: "",
      width: "",
      left_width: "",
      right_width: "",
      wood_type: "",
      hang: "",
      posts_selected: [],
      ironmongery_selected: [],
      treatments_selected: [],

      showConfigureModal: false,
      showMeasureModalWidth: false,
      showMeasureModalHeight: false,
      showWoodModal: false,
      showHangModal: false,

      show_post_modal: false,
      postToView: {},
      postOption: {},
      postIndex: -1,

      show_iron_modal: false,
      ironToView: {},
      ironOption: {},
      ironIndex: -1,

      show_treatment_modal: false,
      treatmentToView: {},
      treatmentOption: {},
      treatmentIndex: -1,

      Item: {},
      qty: 1,

      error: false,
      hang_error: false,
      size_error: false,
      show_config: false
    }
  },
  created() {
    this.page.ParentID == this.IDs.saleID ? (this.show_config = false) : (this.show_config = true)
    //this.show_config = true
    if (this.$route.query.edit) {
      var items = this.basket.items.filter(i => i._id == this.$route.query.edit)
      if (items.length) {
        var item = items[0]
        this.Item = item

        this.dimensions = item.dimensions
        this.dimensions ? (this.show_config = false) : (this.show_config = true)

        this.width = item.width
        this.left_width = item.left_width
        this.right_width = item.right_width
        this.height = item.height
        this.wood_type = item.wood_type
        this.hang = item.hang
        this.treatments_selected = item.treatments
        this.posts_selected = item.posts
        this.ironmongery_selected = item.ironmongery
        this.qty = item.qty
      }
    }
    if (this.$route.query.edit) {
      this.showConfigureModal = true
    }
  },
  computed: {
    ...mapState(["IDs", "misc", "posts", "ironmongery", "treatments", "page", "pricing", "basket", "sizing"]),
    priceList() {
      if (!this.page) return null
      if (!this.page.stock_price_list) return null

      if (!this.pricing) return null
      if (!this.pricing.price_lists) return null

      var lists = this.pricing.price_lists.filter(l => l._id == this.page.stock_price_list)
      if (!lists.length) return null

      return lists[0]
    },
    filteredPosts() {
      if (this.posts)
        return this.posts.filter(post => post.available_on && post.available_on.includes(this.page.ParentID))
      return []
    },
    filteredIronmongery() {
      if (this.ironmongery)
        return this.ironmongery.filter(iron => iron.available_on && iron.available_on.includes(this.page.ParentID))
      return []
    },
    filteredTreatments() {
      if (this.treatments) {
        var treatments = JSON.parse(JSON.stringify(this.treatments))

        treatments.forEach(
          treatment =>
            (treatment.options = treatment.options.filter(option => {
              if (!option.available_on) return false

              var byWoodType =
                this.wood_type.indexOf("Hardwood") > -1
                  ? option.available_on.includes("Hardwood")
                  : option.available_on.includes("Softwood")

              return option.available_on && option.available_on.includes(this.page.ParentID) && byWoodType
            }))
        )
        return treatments.filter(treatment => treatment.options.length)
      }

      return []
    },
    sizeAndWoodType: function() {
      var val = ""
      if (this.width && this.height) val = this.width + "mm x " + this.height + "mm "
      else if (this.left_width && this.right_width && this.height)
        val = this.left_width + "mm x " + this.height + "mm, " + this.right_width + "mm x " + this.height + "mm "
      else if (this.left_width && this.height) val = this.left_width + "mm x " + this.height + "mm"
      else if (this.right_width && this.height) val = this.right_width + "mm x " + this.height + "mm"
      else if (this.left_width) val = "Width: " + this.left_width + "mm"
      else if (this.right_width) val = "Width: " + this.right_width + "mm"
      else if (this.width) val = "Width: " + this.width + "mm"
      else if (this.height) val = "Height: " + this.height + "mm "

      if (this.wood_type) {
        if (this.width || this.left_width || this.right_width || this.height) val = val + " ("
        val = val + this.wood_type
        if (this.width || this.left_width || this.right_width || this.height) val = val + ")"
      }
      if (this.hang) {
        val = val + " " + this.hang + " Hang"
      }

      return val.trim()
    },
    postsText: function() {
      if (this.posts_selected.length) {
        return "Posts selected"
      } else {
        return "None selected"
      }
    },
    ironmongeryText: function() {
      if (this.ironmongery_selected.length) {
        return "Ironmongery selected"
      } else {
        return "None selected"
      }
    },
    treatmentText: function() {
      if (this.treatments_selected.length == 1)
        return this.treatments_selected[0].name + " (" + this.treatments_selected[0].option.name + ")"
      if (this.treatments_selected.length > 1) return "Treatments selected"
      return "None selected"
    },
    totalPrice: function() {
      var total = 0

      var price_type = this.page.price_type.toLowerCase()
      if (this.dimensions) {
        total = Number(this.dimensions.price)
      } else {
        total = Number(this.page.base_price)

        if ((this.width || (this.left_width && this.right_width)) && this.height) {
          // Dimension costs
          total = total + this.calcDimensionCost(this.height, "height", price_type)
          total =
            total +
            this.calcDimensionCost(
              this.width || Number(this.left_width) + Number(this.right_width),
              "width",
              price_type
            )
        }
      }

      // Hardwood supplement
      if (this.wood_type.indexOf("Hardwood") > -1 && this.pricing[price_type + "_hardwood_supplement"]) {
        var supplementpercent = Number(this.pricing[price_type + "_hardwood_supplement"]) / 100
        var supplementamount = total * supplementpercent

        total = total + supplementamount
      }

      // Posts, ironmongery, treatment
      this.posts_selected.forEach(post => (total = total + Number(post.option.price)))
      this.ironmongery_selected.forEach(post => (total = total + Number(post.option.price)))
      this.treatments_selected.forEach(treatment => (total = total + Number(treatment.option.price)))

      return total.toFixed(2).replace(".00", "")
    }
  },
  methods: {
    woodTypeChanged() {
      this.treatments_selected = this.treatments_selected.filter(t => {
        var byWoodType =
          this.wood_type.indexOf("Hardwood") > -1
            ? t.option.available_on.includes("Hardwood")
            : t.option.available_on.includes("Softwood")

        return t.option.available_on.includes(this.page.ParentID) && byWoodType
      })
    },
    setDimensions() {
      this.width = this.dimensions.width
      this.height = this.dimensions.height
      if (this.wood_type) {
        if (this.wood_type == "Scandinavian Redwood" && !this.dimensions.softwood) this.wood_type = ""
        if (this.wood_type == "African Iroko Hardwood" && !this.dimensions.hardwood) this.wood_type = ""
      }
    },
    hideConfig() {
      this.show_config = false
      this.dimensions = null
      this.left_width = ""
      this.right_width = ""
      this.width = ""
      this.height = ""
    },
    showConfig() {
      this.show_config = true
      this.dimensions = null
      this.left_width = ""
      this.right_width = ""
      this.width = ""
      this.height = ""
    },
    scrollToConfigurator() {
      var element = document.getElementById("configure")
      element.scrollIntoView()
    },
    addToCart() {
      this.error = false
      this.hang_error = false
      this.size_error = false

      if (!(this.width || (this.left_width && this.right_width)) || !this.height || !this.wood_type) {
        this.error = true
        return false
      }
      if (
        !this.hang &&
        this.page.price_type == "Single" &&
        this.page.ParentID != this.IDs.sidePanelID &&
        this.page.ParentID != this.IDs.saleGatesID
      ) {
        this.hang_error = true
        return false
      }

      if (this.sizing) {
        if (this.width && this.sizing.min_width && Number(this.width) < this.sizing.min_width) {
          this.size_error = true
          return false
        }
        if (this.width && this.sizing.max_width && Number(this.width) > this.sizing.max_width) {
          this.size_error = true
          return false
        }

        if (
          this.left_width &&
          this.right_width &&
          this.sizing.min_width &&
          Number(this.left_width) + Number(this.right_width) < this.sizing.min_width
        ) {
          this.size_error = true
          return false
        }
        if (
          this.left_width &&
          this.right_width &&
          this.sizing.max_width &&
          Number(this.left_width) + Number(this.right_width) > this.sizing.max_width
        ) {
          this.size_error = true
          return false
        }

        if (this.height && this.sizing.min_height && Number(this.height) < this.sizing.min_height) {
          this.size_error = true
          return false
        }
        if (this.height && this.sizing.max_height && Number(this.height) > this.sizing.max_height) {
          this.size_error = true
          return false
        }
      }

      var _id = shortid.generate()
      if (this.$route.query.edit) {
        _id = this.Item._id

        this.basket.items = this.basket.items.filter(i => i._id != this.$route.query.edit)
      }

      var item = {
        _id,
        product: {
          name: this.page.name,
          category: this.page.ParentID,
          ItemID: this.page.ItemID,
          url: this.page.url,
          price_type: this.page.price_type
        },
        dimensions: this.dimensions,
        left_width: this.left_width,
        right_width: this.right_width,
        width: this.width,
        height: this.height,
        wood_type: this.wood_type,
        hang: this.hang,
        treatments: this.treatments_selected,
        posts: this.posts_selected,
        ironmongery: this.ironmongery_selected,
        qty: this.qty,
        product_type: "gate",
        price: Number(this.totalPrice)
      }

      this.$store.commit("basket/addItem", item)
      this.$nextTick().then(() => {
        this.$router.push("basket")
      })
    },
    calcDimensionCost(totaldim, dimtype, pricetype) {
      totaldim = Number(totaldim)
      var costs = this.pricing[pricetype + "_" + dimtype]
      var additionalcost = 0

      // Find the highest cost bracket which is less than the height entered
      costs.sort((a, b) => (a[dimtype] < b[dimtype] ? 1 : b[dimtype] < a[dimtype] ? -1 : 0))

      // Previous bracket size set to chosen dimension initially
      var bracketdim = totaldim
      costs.forEach(cost => {
        // Find the highest cost bracket which is less than the height entered
        // Subtract current bracket size from previous bracket size
        // Multiply by bracket cost
        if (cost[dimtype] < bracketdim) {
          additionalcost = additionalcost + (bracketdim - cost[dimtype]) * (cost.cost_per_mm / 100)

          // Set previous bracket cost
          bracketdim = cost[dimtype]
        }
      })

      return additionalcost
    },
    showPostModal(post) {
      this.postToView = post
      this.show_post_modal = true
    },
    editPost(index) {
      this.postToView = this.posts.filter(p => p.ItemID == this.posts_selected[index].ItemID)[0]
      this.postOption = this.postToView.options.filter(p => p._id == this.posts_selected[index].option._id)[0]
      this.postIndex = index
      this.show_post_modal = true
    },
    addPost() {
      if (this.postOption._id) {
        var post_option = JSON.parse(JSON.stringify(this.postToView))
        delete post_option.options
        post_option.option = this.postOption

        if (this.postIndex > -1) this.$set(this.posts_selected, this.postIndex, post_option)
        else this.posts_selected.push(post_option)

        this.postToView = {}
        this.postOption = {}
        this.postIndex = -1

        this.show_post_modal = false
      }
    },
    showIronModal(iron) {
      this.ironToView = iron
      this.show_iron_modal = true
    },
    editIron(index) {
      this.ironToView = this.ironmongery.filter(p => p.ItemID == this.ironmongery_selected[index].ItemID)[0]
      this.ironOption = this.ironToView.options.filter(p => p._id == this.ironmongery_selected[index].option._id)[0]
      this.ironIndex = index
      this.show_iron_modal = true
    },
    addIron() {
      if (this.ironOption._id) {
        var iron_option = JSON.parse(JSON.stringify(this.ironToView))
        delete iron_option.options
        iron_option.option = this.ironOption

        if (this.ironIndex > -1) this.$set(this.ironmongery_selected, this.ironIndex, iron_option)
        else this.ironmongery_selected.push(iron_option)

        this.ironToView = {}
        this.ironOption = {}
        this.ironIndex = -1

        this.show_iron_modal = false
      }
    },
    showTreatmentModal(treatment) {
      this.treatmentToView = treatment
      this.show_treatment_modal = true
    },
    editTreatment(index) {
      this.treatmentToView = this.treatments.filter(p => p.ItemID == this.treatments_selected[index].ItemID)[0]
      this.treatmentOption = this.treatmentToView.options.filter(
        p => p._id == this.treatments_selected[index].option._id
      )[0]
      this.treatmentIndex = index
      this.show_treatment_modal = true
    },
    addTreatment() {
      if (this.treatmentOption._id) {
        var treatment_option = JSON.parse(JSON.stringify(this.treatmentToView))
        delete treatment_option.options
        treatment_option.option = this.treatmentOption

        if (this.treatmentIndex > -1) this.$set(this.treatments_selected, this.treatmentIndex, treatment_option)
        else this.treatments_selected.push(treatment_option)

        this.treatmentToView = {}
        this.treatmentOption = {}
        this.treatmentIndex = -1

        this.show_treatment_modal = false
      }
    },
    removePost(index) {
      this.posts_selected.splice(index, 1)
    },
    removeIron(index) {
      this.ironmongery_selected.splice(index, 1)
    },
    removeTreatment(index) {
      this.treatments_selected.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.error {
  color: red;
}

.modal-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 4rem;
}

.modal-container img {
  max-height: 80vh;
}

.configure {
  clear: both;
  background-color: #f5f5f5;
  padding: 5rem;
  color: #333;
  margin: 5rem 0;
  font-size: 1.6rem;
  text-align: center;
}

.title {
  font-size: 2.75rem;
  font-weight: bold;
  color: #434f50;
}

.steps {
  margin-top: 2rem;
  font-size: 2rem;
}

.steps > a {
  display: table;
  width: 100%;
  padding: 2rem 2rem;
  text-align: left;
  margin: auto;
  background: white;
  margin-top: 1rem;
  font-weight: bold;
  clear: both;
}

.steps > a:hover {
  background-color: #e6e6e6;
}

.steps > a span:first-child {
  display: inline-block;
  margin-right: 2rem;
}

.steps > a span:first-child i {
  display: inline-block;
  background: #f79227;
  font-size: 1.5rem;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  color: #fff;
  text-align: center;
  border-radius: 100%;
}

.steps > a span:last-child {
  float: right;
  font-style: italic;
  color: #ccc;
  font-size: 1.5rem;
  line-height: 3.3rem;
  padding-left: 2rem;
}

.step-info {
  display: none;
  padding: 3rem 2rem;
  background: white;
  float: left;
  margin-bottom: 2rem;
  width: 100%;
  text-align: left;
}

.step-info p {
  clear: left;
}

.step-info.default {
  display: block;
}

.step-info .row {
  padding: 1rem 0;
  clear: left;
}

.step-info .row label {
  width: 20rem;
  display: inline-block;
}

.step-info .row .option {
  display: inline-block;
}

.step-info .row .help {
  display: inline-block;
  margin-left: 1rem;
  color: #f79227;
}

.step-info .row .help .desktop {
  font-size: 1.4rem;
  color: #333;
  margin-left: 1rem;
}

.step-info select {
  font-size: 1.5rem;
  padding: 0.5rem 1rem;
}

.accessories p {
  margin-top: 0;
  padding-top: 0;
}

.accessories a {
  display: block;
  float: left;
  width: 8%;
  margin: 1% 1%;
  text-align: center;
  font-size: 1.5rem;
}

.colours .grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-gap: 2rem;
}

.colours a {
  text-align: center;
  font-size: 1.5rem;
  line-height: 1.3;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .colours .grid {
    display: table;
    width: 100%;
  }
  .colours a {
    display: block;
    float: left;
    width: 8%;
    margin: 1% 1%;
    text-align: center;
    font-size: 1.5rem;
  }
}

.accessories a {
  width: 18%;
  padding: 0 1%;
  line-height: 1.3;
}

.colours a img {
  width: 100%;
  border-radius: 100%;
  transition: all 0.2s;
  margin-bottom: 1rem;
}

.accessories a img {
  width: 100%;
  border: 4px solid #fff;
  margin-bottom: 1rem;
}

.accessories a img:hover {
  border: 4px solid #d4d4d4;
}

.colours a:hover img {
  transform: scale(1.05);
}

.config-total {
  font-size: 2rem;
  margin-top: 3rem;
}

.txt-size {
  -webkit-appearance: none;
  border: 1px solid #d5d5d5;
  padding: 1rem;
  width: 100px;
}

.add-to-basket {
  font-size: 2rem;
}
.add-to-basket select {
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  margin-right: 1rem;
  max-width: 35rem;
}
.add-to-basket button {
  padding: 0.5rem 1rem;
  font-size: 2rem;
  border: 0;
  background: #434f50;
  border-bottom: 5px solid #f79227;
  color: white;
  position: relative;
  cursor: pointer;
}
.limited {
  max-width: 30rem;
}

h4 {
  margin: 0;
  padding: 0;
}

.row.divider {
  padding-top: 2rem;
  display: table;
  width: 100%;
}

.row.divider:first-child {
  padding-top: 0;
  margin-top: -2rem;
}

.selected {
  padding: 2rem 3rem;
  background: #f5f5f59a;
  clear: both;
  margin: 2rem 0;
}

.selected > div {
  text-align: left;
  font-size: 1.5rem;
  width: 100%;
  display: table;
}

.notice {
  background: #f79227;
  color: white;
  font-size: 1.4rem;
  display: inline-block;
  padding: 0 1rem !important;
}

.accessories a.del,
.colours a.del {
  display: inline-block;
  float: none;
  width: auto;
  color: #cc0000;
}

.edit {
  display: inline-block !important;
  width: auto !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  text-align: left !important;
  max-width: 90%;
}

.switch a {
  font-size: 1.5rem;
  padding: 1rem 1.5rem;
  border: 1px solid #ccc;
  margin-top: 2rem;
  display: inline-block;
}

.switch.stock {
  margin-top: -2rem;
}

.switch.stock a {
  margin-top: 0;
  margin-bottom: 2rem;
}

.switch a:hover {
  background-color: #fafafa;
}

.modal-btn {
  background: #f79227;
  color: white;
  padding: 1rem 2rem;
  border: 0;
  cursor: pointer;
}

@media screen and (max-width: 1000px) {
  .colours .grid {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media screen and (max-width: 750px) {
  .configure {
    padding: 3rem 2rem;
  }

  .configure .inner {
    padding: 0;
  }

  .accessories .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 2rem;
  }

  .accessories a {
    width: 100%;
  }
  .colours .grid {
    grid-template-columns: repeat(6, 1fr);
  }
  .modal-grid {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
  .limited {
    max-height: 20rem;
    margin: auto;
    display: block;
  }
}
@media screen and (max-width: 500px) {
  .accessories .grid {
    grid-template-columns: 1fr 1fr;
  }

  .colours .grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
